import { ContentViewStyle } from '@levelapp/softfabric';
export default class ButtonViewStyle extends ContentViewStyle {
    constructor() {
        super(...arguments);
        this.borderRadiusLittle = {
            borderRadius: 4,
            paddingVertical: 8,
            paddingHorizontal: 25,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        };
        this.borderRadius = {
            borderRadius: 100,
            paddingVertical: 8,
            paddingHorizontal: 25,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        };
        this.noBorderRadius = {
            paddingVertical: 8,
            paddingHorizontal: 25,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        };
        this.testShadow = {
            shadowOpacity: 0.5,
        };
    }
}
